// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info-block[data-v-7b689687]{background-color:#f6f6f6;border-radius:4px;padding:16px;font-style:normal;font-weight:400;font-size:16px;line-height:22px}", ""]);
// Exports
module.exports = exports;
